var map = {
	"./taskIcon0.png": 21809,
	"./taskIcon1.png": 81864,
	"./taskIcon2.png": 18723,
	"./taskIcon3.png": 13498,
	"./taskIcon4.png": 71445,
	"./taskIcon5.png": 88556,
	"./taskIcon6.png": 73383,
	"./taskIcon7.png": 85694,
	"./taskIcon8.png": 84585,
	"./taskIcon9.png": 29760
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 43806;